const DEFAULT_SUCCESS_MESSAGE =
  "Данные отправлены. Мы свяжемся с вами в ближайшее рабочее время.";
const DEFAULT_ERROR_MESSAGE =
  "Не удалось отправить заявку. Проверьте данные и попробуйте ещё раз.";

const WRAP_CLASS = "async-form";
const MESSAGE_CLASS = "async-form-message";
const SUCCESS_CLASS = "async-form-message--success";
const ERROR_CLASS = "async-form-message--error";
const CLOSE_CLASS = "async-form-message__close";
const TEXT_CLASS = "async-form-message__text";
const AUTO_HIDE_MS = 15000;

const getCsrfToken = () => {
  const tokenTag = document.querySelector("meta[name='csrf-token']");
  return tokenTag ? tokenTag.content : null;
};

const ensureMessageContainer = (form) => {
  let container = form.querySelector(`.${MESSAGE_CLASS}`);
  if (!container) {
    container = document.createElement("div");
    container.className = MESSAGE_CLASS;
    container.setAttribute("role", "status");
    container.setAttribute("aria-live", "polite");

    const text = document.createElement("div");
    text.className = TEXT_CLASS;
    container.appendChild(text);

    const close = document.createElement("button");
    close.type = "button";
    close.className = CLOSE_CLASS;
    close.setAttribute("aria-label", "Закрыть сообщение");
    close.innerHTML = "&times;";
    close.addEventListener("click", () => hideMessage(form));
    container.appendChild(close);

    form.prepend(container);
  }
  return container;
};

const clearAutoHide = (form) => {
  const timeoutId = form.dataset.asyncFormTimeoutId;
  if (timeoutId) {
    clearTimeout(Number(timeoutId));
    delete form.dataset.asyncFormTimeoutId;
  }
};

const hideMessage = (form) => {
  const container = form.querySelector(`.${MESSAGE_CLASS}`);
  if (!container) return;
  container.classList.remove(SUCCESS_CLASS, ERROR_CLASS);
  container.classList.remove("is-visible");
  clearAutoHide(form);
};

const setMessage = (form, message, type) => {
  const container = ensureMessageContainer(form);
  container.classList.remove(SUCCESS_CLASS, ERROR_CLASS);
  if (type === "success") {
    container.classList.add(SUCCESS_CLASS);
  }
  if (type === "error") {
    container.classList.add(ERROR_CLASS);
  }
  const text = container.querySelector(`.${TEXT_CLASS}`);
  if (text) {
    text.textContent = message;
  }
  container.classList.add("is-visible");
  clearAutoHide(form);
  const timeoutId = window.setTimeout(() => hideMessage(form), AUTO_HIDE_MS);
  form.dataset.asyncFormTimeoutId = String(timeoutId);
};

const setSubmittingState = (form, isSubmitting) => {
  const buttons = form.querySelectorAll("button, input[type='submit']");
  buttons.forEach((button) => {
    button.disabled = isSubmitting;
  });
};

const submitForm = async (form) => {
  const action = form.getAttribute("action");
  const method = (form.getAttribute("method") || "post").toUpperCase();
  const formData = new FormData(form);

  const headers = { Accept: "application/json" };
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    headers["X-CSRF-Token"] = csrfToken;
  }

  let response;
  let payload = null;

  try {
    response = await fetch(action, {
      method,
      headers,
      body: formData,
      credentials: "same-origin",
    });
  } catch (error) {
    setMessage(
      form,
      form.dataset.asyncFormErrorMessage || DEFAULT_ERROR_MESSAGE,
      "error"
    );
    return;
  }

  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }
  }

  const ok = response.ok && (!payload || payload.ok !== false);
  if (ok) {
    setMessage(
      form,
      form.dataset.asyncFormMessage || DEFAULT_SUCCESS_MESSAGE,
      "success"
    );
    form.reset();
  } else {
    setMessage(
      form,
      (payload && payload.message) ||
        form.dataset.asyncFormErrorMessage ||
        DEFAULT_ERROR_MESSAGE,
      "error"
    );
  }
};

const initAsyncForms = () => {
  const forms = document.querySelectorAll("form[data-async-form]");
  forms.forEach((form) => {
    if (form.dataset.asyncFormBound === "true") return;
    form.dataset.asyncFormBound = "true";
    form.classList.add(WRAP_CLASS);

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      setSubmittingState(form, true);
      await submitForm(form);
      setSubmittingState(form, false);
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAsyncForms);
} else {
  initAsyncForms();
}

document.addEventListener("turbo:load", initAsyncForms);
